import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useApi } from './ApiContext';
import { useWorkspace } from './WorkspaceContext';
import { FeedbackModal } from '~/components';

const FeedbackContext = createContext();

const FeedbackProvider = ({ children }) => {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  const handleCloseFeedbackModal = () => {
    setShowFeedbackModal(false);
  };

  const openFeedbackModal = useCallback(() => {
    setShowFeedbackModal(true);
  }, []);

  const submitFeedback = useCallback(
    async (values, files) => {
      try {
        const { data } = await api.www.workspaces(workspace.id).feedbackItems().create(values);

        await Promise.all(
          files.map(async (file) => {
            await api.www
              .workspaces(workspace.id)
              .feedbackItems(data.id)
              .files()
              .upload({
                name: file.name,
                type: file.type,
                data: file.dataUrl.split(';base64,').pop(),
              });
          }),
        );

        return { success: true };
      } catch (error) {
        return { success: false, message: error.message };
      }
    },
    [api.www, workspace?.id],
  );

  const values = useMemo(() => {
    return {
      openFeedbackModal,
      submitFeedback,
    };
  }, [openFeedbackModal, submitFeedback]);

  return (
    <FeedbackContext.Provider value={values}>
      {children}
      {showFeedbackModal && <FeedbackModal onClose={handleCloseFeedbackModal} />}
    </FeedbackContext.Provider>
  );
};

function useFeedback() {
  return useContext(FeedbackContext);
}

export { FeedbackContext, useFeedback, FeedbackProvider };
